export const CONTACT_EMAIL = "info@constellation-academy.com";
